import { render, staticRenderFns } from "./AbilityCenter.vue?vue&type=template&id=337b3334&scoped=true"
import script from "./AbilityCenter.vue?vue&type=script&lang=js"
export * from "./AbilityCenter.vue?vue&type=script&lang=js"
import style0 from "./AbilityCenter.vue?vue&type=style&index=0&id=337b3334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b3334",
  null
  
)

export default component.exports